



























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SLoader extends Vue {
  @Prop({ default: true, type: Boolean }) public show!: boolean;
  @Prop(Boolean) public fullPage?: boolean;
  @Prop(HTMLElement) public element?: HTMLElement;
  @Prop(Number) public id?: number;

  public paddingLeft = '';
  public paddingTop = '';

  public mounted() {
    if (this.fullPage) {
      const app = this.$root.$el as HTMLElement;
      this.paddingLeft = app.style.paddingLeft || '';
      this.paddingTop = app.style.paddingTop || '';
    } else if (this.$el.parentElement) {
      (this.$el.parentElement as HTMLElement).style.position = 'relative';
      (this.$el.parentElement as HTMLElement).style.minHeight =
        (this.$el.parentElement as HTMLElement).style.minHeight || '30px';
    } else if (this.element) {
      this.element.style.position = 'relative';
      this.element.style.minHeight = this.element.style.minHeight || '30px';
    }
  }
}
